import React, { useState } from 'react';
import { ButtonPlate, Container, Description, Text, Span, Title, WrapDescription, TitleModal, TextFooter, ItemListWrap } from '../styled';
import { LinkStyled, Space } from '@gr-monorepo/common/ui';
import ModalContainer from './ModalContainer';
import Modal from './Modal';
import { useClickStreamContext } from 'features/shared/ClickStream';

const link =
  'https://distant.uchi.ru/underachievement?utm_source=site&utm_medium=email&utm_campaign=b2t_neu_pop_up';
  
const messageTextToCopy = (linkUtm: string) =>
  `Здравствуйте! На Учи.ру до 16 декабря включительно можно зарегистрироваться на курс повышения квалификации для учителей 1–4 классов «Неуспеваемость и трудное поведение в школе: причины возникновения и методы коррекции». \n \nЭксперты — педагоги высшей категории, кандидаты наук и практикующие психологи. Они расскажут, как:  \n \n• определять причины неуспеваемости и трудного поведения; \n• выстраивать индивидуальные образовательные траектории; \n• адаптировать программу для детей с медлительностью и СДВГ. \n \nОбъем материалов — 72 академических часа. При успешном освоении программы слушатели получат удостоверение, зарегистрированное в ФИС ФРДО. \n \nПожалуйста, передайте информацию о курсе учителям и пригласите их записаться: ${linkUtm}`;

const UnderachievementContentModal = ({ linkUtm }: { linkUtm: string }) => {
  return (
    <>
      <TitleModal>
        Скопируйте это сообщение и отправьте <br />
        муниципалитетам:
      </TitleModal>
      <Description>
        <WrapDescription>
          <p>
          Здравствуйте! На Учи.ру до 16 декабря включительно можно зарегистрироваться на курс повышения квалификации для учителей <br/>1–4 классов «Неуспеваемость и трудное поведение в школе: причины возникновения и методы коррекции».
          </p>
          <div style={{ display: 'grid', gap: '12px' }}>
            <p>Эксперты — педагоги высшей категории, кандидаты наук и&nbsp;практикующие психологи. Они расскажут, как: </p>
            <div style={{ display: 'grid', gap: '8px', paddingLeft: '12px' }}>
              <ItemListWrap><span>•</span><p>определять причины неуспеваемости и трудного поведения;</p></ItemListWrap>
              <ItemListWrap><span>•</span><p>выстраивать индивидуальные образовательные траектории;</p></ItemListWrap>
              <ItemListWrap><span>•</span><p>адаптировать программу для детей с медлительностью и СДВГ.</p></ItemListWrap>
            </div>
          </div>
          <p>
          Объем материалов — 72 академических часа. При успешном освоении программы слушатели получат удостоверение, зарегистрированное в&nbsp;ФИС ФРДО.
          </p>
          <p>
          Пожалуйста, передайте информацию о курсе учителям и пригласите их записаться:
            <LinkStyled style={{ color: '#7F39FB' }} href={linkUtm} target="_blank">
              {' '}
              https://distant.uchi.ru/underachievement
            </LinkStyled>
          </p>
        </WrapDescription>
      </Description>
    </>
  );
};
const Underachievement = ({ id }: { id: number }) => {
  const [isOpenModal, setOpenModal] = useState<boolean>(false);
  const [isCopied, setCopied] = useState<boolean>(false);
  const utm = `&cabmun_id=${id}`;
  const linkUtm = link + utm;
  const { logPageEvent } = useClickStreamContext();

  const handleOpenModal = () => {
    setOpenModal(true);
    logPageEvent?.({
      eventType: 'main_page_info_kpk_underachievement',
      eventInfo: 'Клик по кнопке: Поделиться информацией в плашке Неуспеваемость и трудное поведение в школе',
    });
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setCopied(false);
  };

  const handleCopyClick = () => {
    navigator.clipboard.writeText(messageTextToCopy(linkUtm)).then(() => {
      setCopied(true);
      logPageEvent?.({
        eventType: 'main_page_info_kpk_modal_underachievement',
        eventInfo: 'Клик по кнопке: Скопировать в модальном окне Неуспеваемость и трудное поведение в школе',
      });
    });
  };
  return (
    <>
      <Container>
        <WrapDescription>
          <Title>Бесплатный курс повышения квалификации Учи.ру для педагогов 1-4 классов</Title>
          <Text>Неуспеваемость и трудное поведение в&nbsp;школе: причины возникновения и&nbsp;методы&nbsp;коррекции</Text>
          <Text>Эксперты расскажут, как предупреждать и&nbsp;преодолевать сложности в обучении, адаптировать программу и отслеживать прогресс школьников. Учителя региона познакомятся с инструментами, которые помогут выстроить индивидуальные образовательные траектории и создать поддерживающую обстановку в классе.</Text>
        </WrapDescription>
        <div>
          <ButtonPlate color={'violet'} onClick={handleOpenModal}>
            Поделиться информацией о курсе
          </ButtonPlate>
          <Space size={16} axis="vertical" />
          <TextFooter>За успешное освоение программы выдается удостоверение, зарегистрированное в ФИС ФРДО.</TextFooter>
        </div>
      </Container>

      {isOpenModal && (
        <ModalContainer onClose={handleCloseModal}>
          <Modal isCopied={isCopied} onClick={handleCopyClick}>
            <UnderachievementContentModal linkUtm={linkUtm} />
          </Modal>
        </ModalContainer>
      )}
    </>
  );
};

export default Underachievement;
